import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingState = signal<boolean>(false);
  private loadingTasks = signal<Set<string>>(new Set());

  isLoading = this.loadingState.asReadonly();

  show(taskId?: string): void {
    console.log('🟢 LoadingService.show() called with taskId:', taskId);
    if (taskId) {
      this.loadingTasks.update(tasks => new Set(tasks).add(taskId));
      console.log('📝 Active loading tasks:', Array.from(this.loadingTasks()));
    }
    this.loadingState.set(true);
    console.log('🔄 Global loading state set to:', true);
  }

  hide(taskId?: string): void {
    console.log('🔴 LoadingService.hide() called with taskId:', taskId);
    if (taskId) {
      this.loadingTasks.update(tasks => {
        const newTasks = new Set(tasks);
        newTasks.delete(taskId);
        console.log('📝 Remaining loading tasks after removal:', Array.from(newTasks));
        return newTasks;
      });
      
      // Only hide loading if no tasks are running
      if (this.loadingTasks().size === 0) {
        this.loadingState.set(false);
        console.log('✅ All tasks completed, global loading state set to:', false);
      } else {
        console.log('⏳ Still waiting for tasks:', Array.from(this.loadingTasks()));
      }
    } else {
      this.loadingState.set(false);
      this.loadingTasks.set(new Set());
      console.log('🧹 LoadingService cleared all tasks and set loading to:', false);
    }
  }

  hideAll(): void {
    console.log('🧹 LoadingService.hideAll() called - clearing all loading states');
    console.log('📝 Tasks being cleared:', Array.from(this.loadingTasks()));
    this.loadingState.set(false);
    this.loadingTasks.set(new Set());
    console.log('✅ All loading states cleared');
  }

  isTaskLoading(taskId: string): boolean {
    return this.loadingTasks().has(taskId);
  }

  setLoading(state: boolean): void {
    this.loadingState.set(state);
  }
}
